import { render, staticRenderFns } from "./NewStowageEdit.vue?vue&type=template&id=10a6ec1b&scoped=true&"
import script from "./NewStowageEdit.vue?vue&type=script&lang=js&"
export * from "./NewStowageEdit.vue?vue&type=script&lang=js&"
import style0 from "./NewStowageEdit.vue?vue&type=style&index=0&id=10a6ec1b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a6ec1b",
  null
  
)

export default component.exports